import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import {getDayName, orange, getMonthName} from "../utils";

const DateBoxStyled = styled(Box)(({ theme }) => ({
    // backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '60px',
    borderRight: "1px solid rgba(0, 0, 0, 0.2)",
    borderRadius: "0px",
}));

const StyledDay = styled(Typography)(() => ({
    fontWeight: 800,
    fontSize: '1rem',
}));

const StyledDate = styled(Typography)(() => ({
    fontWeight: 900,
    fontSize: '1.5rem',
}));

const getMonth = (eventDate, type) => {
    const date = new Date(eventDate);
    const month = getMonthName(date.getMonth());
    return ( month)
}
const DateBox = ({date, isToday}) => {
    return (
        <DateBoxStyled>
            <StyledDay variant="body2" sx={{color: isToday ? orange[500]: '#000000'}}>{getDayName(date.getDay())}</StyledDay>
            <StyledDate variant="h5" sx={{color: isToday ? orange[500]: '#000000'}}>{date.getDate()}</StyledDate>
            <StyledDay variant="body2" sx={{color: isToday ? orange[500]: '#000000'}}>{getMonth(date)}</StyledDay>
        </DateBoxStyled>
    );
};

export default DateBox;